<template>
  <el-row :gutter="20">
    <el-col :span="12">
      <MaterialTable :height="height" />
    </el-col>
    <el-col :span="12">
      <PackageTable ref="packageTable" :height="height" :packValue="value" />
    </el-col>
  </el-row>
</template>
<script>
import MaterialTable from './material-table'
import PackageTable from './package-table'
export default {
  components: { MaterialTable, PackageTable },
  props: {
    height: { type: Number, default: 500 },
    value: { type: Array, default: () => [] },
  },
  methods: {
    async getPackageData() {
      return await this.$refs.packageTable.getTableData()
    },
  },
}
</script>
